export function contactRadioCheck(selectedValues = []) {
  // selectedValues は PHP から渡される選択されたチェックボックスの値の配列

  // フォーム内のチェックボックス要素を取得
  var checkboxes = document.querySelectorAll("input[type='checkbox']");

  checkboxes.forEach(function(checkbox) {
    var checkVal = checkbox.value;
    
    // 入力画面で選択した選択肢と同じ選択肢のときは、その値をチェックする
    if (selectedValues.includes(checkVal)) {
      checkbox.checked = true;
    }
  });
}

// ページ読み込み時に特定の資料にチェックを入れる
document.addEventListener('DOMContentLoaded', function() {
  var material = localStorage.getItem('selectedMaterial');
  if (material) {
    // 各資料のオプション内のチェックボックスを探してチェック
    var checkboxes = document.querySelectorAll(`input[type='checkbox'][value="${material}"]`);
    checkboxes.forEach(function(checkbox) {
      checkbox.checked = true;
    });

    // 使用後にlocalStorageから削除
    localStorage.removeItem('selectedMaterial');
  }
  
});